module.exports = __webpack_public_path__ + "img/addr-empty@2x.a9acb9c6.png";